import { render } from "./DotsLoading.vue?vue&type=template&id=593c2a95"
import script from "./DotsLoading.vue?vue&type=script&lang=js"
export * from "./DotsLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__